import React from 'react';
import { PlusCircleIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/components/capstone/base';
import { EmptyContainer } from './Inbound.styles';
import { IconWrapper } from './Main.styles';

const EmptyInbound = ({ toggleAddCredentialModal }) => {
  return (
    <Box height="100%">
      <EmptyContainer height="inherit">
        <IconWrapper
          onClick={toggleAddCredentialModal}
          color={'heavyLineOutline'}
        >
          <PlusCircleIcon />
        </IconWrapper>
        <Box width={128} justify="center" mt={'18px'}>
          <Text
            textAlign=" center"
            size="normal"
            fontWeight="bold"
            color="secondaryText"
            inline
          >
            Add a Credential
          </Text>
          <Text textAlign=" center" size="normal" color="secondaryText" inline>
            to begin connecting inbound data
          </Text>
        </Box>
      </EmptyContainer>
    </Box>
  );
};

export default EmptyInbound;
